/* eslint-disable */
import SmallButton from "Components/common/components/SmallButton";
import TagTip from "Components/common/components/TagTip";
import TagSkeleton from "Components/common/skeleton/TagSkeleton";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { boxShadow, primaryBgColor, primaryFont, secondaryFont, wBold, wMBold, wMedium, primaryHeadingColor, maxWidth, retina, maxTablet, maxMobile } from "../../../Utils/utilsStyle";
import { actions as personProfileActions } from 'Slice/PersonProfileSlice';
import SmartSourcedContentPopup from "Components/common/modal/SmartSourcedContentPopup";
import { isGuest } from "Utils/UtilityFunctions";
import classNames from "classnames";

const Wrapper = styled.div`
  border-radius: 8px;
  padding: 48px 15px 33px 25px;
  box-shadow: ${boxShadow};
  background-color: #fff;
  margin-bottom: 20px;
  &.listViewIntentData {
    padding: 24px 16px 24px 24px;
  }
  @media all and (max-width: ${maxWidth}) , ${retina} {
    border-radius: 8px;
    padding: 36px 30px 30px 30px;
    margin-bottom: 8px;
  }
  @media all and (max-width: ${maxTablet}) {
    padding: 30px 12px 20px 12px !important;
  }
  .heading {
    font-size: 27px;
    line-height: 31px;
    letter-spacing: -0.669406px;
    color: ${primaryHeadingColor};
    font-family: ${secondaryFont};
    font-weight: ${wMBold};
    max-width: 60%;
    @media all and (max-width: ${maxWidth}) , ${retina} {
      font-size: 19px;
      line-height: 22px;
    }
  }
  .buttonsPart {
     &.listViewButtonDiv {
      flex-direction: row-reverse;
      justify-content: unset;
       @media all and (max-width: ${maxMobile}) {
        flex-direction: column;
      }
    }
    margin-top: 10px;
     button{
      &:active{
       box-shadow: none;
      }
      &:focus {
        box-shadow: none;
      }
    }
    .generate-button {  
      font-family: ${primaryFont};
      font-weight: ${wBold};
      font-size: 15px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 11px;
        padding: 9px 15px;
      }
    }
    .whats-button {
      font-family: ${primaryFont};
      font-weight: ${wMedium};
      font-size: 14px;
      letter-spacing: -0.28px;
      line-height: 30px;
      /* padding: 0; */
      @media all and (max-width: ${maxWidth}) , ${retina} {
        font-size: 10px;
        line-height: 16px;
        padding: 9px 8px;
      }
    }
  }
`;

type Props = {
  name?: string;
  keywords?: string[];
  loading?: boolean;
  intentAllowed?: number;
  url?: string;
  listview?: boolean;
  showButtons?: boolean
  className?: string
};

const defaultProps = {
  name: "Adam",
  keywords: [
    "Web 3D",
    "AR & VR",
    "Blender 3D",
    "Staffing",
    "Talent",
    "Hiring",
    "COVID-19",
  ],
  loading: false,
  intentAllowed: 0,
  url: "",
  listview: false,
  showButtons: true,
  className: ''
};

const PersonIntentData: React.FC<Props> = function PersonIntentData({
  name,
  keywords,
  loading,
  intentAllowed,
  url,
  listview,
  showButtons,
  className
}) {
  const dispatch = useDispatch();

  const generateContent = () => {
    if (intentAllowed && !isGuest()) {
      window.open(url, "_blank");
    } else {
      dispatch(personProfileActions.showGenerateContentRestrictedAccessPopup(true))
    }
  };
  const [showSmartContentPopup, setShowSmartContentPopup] = useState(false);
  const handleOnClickSmartContent = () => {
    setShowSmartContentPopup(true);
  };
  return (
    <Wrapper className={classNames(className, { listViewIntentData: listview })}>
      {showSmartContentPopup ? (
        <SmartSourcedContentPopup
          width="801px"
          description="SmartSourced ™  Content, developed by xiQ, is intelligent content about the interests and topics that matter to each prospect. It is intelligently sourced, curated, and uses proprietary AI to extract insights, from the most reputable sources and combine with your own marketing collateral, about every individual prospect!"
          onClickCancel={() => setShowSmartContentPopup(false)}
          showSmartContentPopup={showSmartContentPopup}
        />
      ) : null}
      {loading ? <TagSkeleton /> : <h6 className="heading">What {name} is talking about right now:</h6>}
      <div className="intent-data-wrap">
        {loading ?
          Array.from(Array(10).keys()).map((i) => (<TagSkeleton />)) :
          keywords?.map((item) => (
            <TagTip key={item} title={item} marginTopBottomSm="3px" />
          ))}
      </div>
      {loading || !showButtons ? null : (
        <div className={classNames("buttonsPart d-flex justify-content-between", { listViewButtonDiv: listview })}>
          <SmallButton
            variant="filled"
            color="#001760"
            title="Generate SmartContent in Workbench"
            className="generate-button"
            onButtonClick={generateContent}
          />
          <SmallButton
            variant="text"
            color="#001760"
            title="What is SmartContent?"
            className="whats-button smallBtnText"
            onButtonClick={handleOnClickSmartContent}
          />
        </div>
      )}
    </Wrapper>
  );
};

PersonIntentData.defaultProps = defaultProps;

export default PersonIntentData;
